import * as api from '@/http'
import Swal from 'vue-sweetalert2'
import Vue from 'vue'

export const ActionSetReceivedSwaps = async ({ commit }) => {
  const swaps_received = await api.http
    .get('dash/employees/scales/swaps/received')
    .then((response) => response.body)
  if (swaps_received.length > 0) {
    try {
      commit('SET_swaps_received', swaps_received)
      Vue.swal({
        icon: 'warning',
        title: 'Atenção!',
        text: 'Você possui solicitações de troca de escala.',
      })
    } catch (e) {
      console.log(e)
    }
  }
}

export const ActionStoreSwap = async ({ commit }, data) => {
  const employee_scales = await api.http
    .post('dash/employees/scales/swaps', data)
    .then((response) => response.body)
  commit('employees/SET_employee_scales', employee_scales, { root: true })
}

export const ActionUpdateSwapRequest = async ({ commit }, payload) => {
  const swaps_received = await api.http
    .put(`dash/employees/scales/swaps/received/${payload.id}`, payload)
    .then((response) => response.body)
  commit('SET_swaps_received', swaps_received)
}

export const ActionCancelSwap = async ({ commit }, swapId) => {
  const employee_scales = await api.http
    .delete(`dash/employees/scales/swaps/${swapId}`)
    .then((response) => response.body)
  commit('employees/SET_employee_scales', employee_scales, { root: true })
}
